import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map, List } from 'immutable';

import PrettyError from '../decorators/PrettyError';
import DisplayError from '../decorators/DisplayError';
import BaseInput from '../helpers/Input';
import Button from '../helpers/Button';
import { AppPage } from '../AppPage';
import { Card } from '../helpers/Card';
import { GridCard } from '../helpers/GridCard';
import { BacklogTable } from './BacklogTable';
import { UserList } from './UserList';

import style from './style.module.css';

const Input = PrettyError(DisplayError(BaseInput));

const BacklogComponent = ({
  users,
  backlogs,
  columnConfigs,
  userLoading,
  backlogLoading,
  currentPage,
  totalPages,
  onChangeUser,
  onSort,
  onMailingClick,
  onDoubleClick,
  onGetNextPageData,
  onReloadClick,
  onSendingEmailTemplatesClick,
  onOneOffApproachClick,
  onGridReady,
  onDateChange,
  dateQuery,
}) => {
  const toolbar = (
    <div className={style.toolbar}>
      <Button onClick={onSendingEmailTemplatesClick}>
        <i aria-hidden="true" className="fa fa-envelope-o" /> Sendgrid Email Templates
      </Button>
      <Button onClick={onOneOffApproachClick}>
        <i aria-hidden="true" className="fa fa-paper-plane-o" /> One-Off Approach
      </Button>
      <Button onClick={onMailingClick}>
        <i aria-hidden="true" className="fa fa-history" /> Mailing History
      </Button>
    </div>
  );

  const usersActions = (
    <>
      <div className={style.date}>
        <Input
          className="input-sm"
          disabled={false}
          name="dateQuery"
          onChange={onDateChange}
          placeholder="Date"
          root={Map({ dateQuery })}
          type="date"
          deep
        />
      </div>
      <Button onClick={onReloadClick}>
        <i aria-hidden="true" className="fa fa-refresh" /> Reload
      </Button>
    </>
  );

  return (
    <AppPage overline="Mailing" title="Backlog" toolbar={toolbar}>
      <Card actions={usersActions} title="Users">
        <UserList loading={userLoading} onChange={onChangeUser} users={users} />
      </Card>
      <GridCard className={style.grid} dense>
        <BacklogTable
          backlogs={backlogs}
          columnConfigs={columnConfigs}
          currentPage={currentPage}
          height="100%"
          loading={backlogLoading}
          onDoubleClick={onDoubleClick}
          onGetNextPageData={onGetNextPageData}
          onGridReady={onGridReady}
          onSort={onSort}
          totalPages={totalPages}
        />
      </GridCard>
    </AppPage>
  );
};

BacklogComponent.propTypes = {
  backlogLoading: PropTypes.bool.isRequired,
  backlogs: PropTypes.instanceOf(List).isRequired,
  columnConfigs: PropTypes.instanceOf(List).isRequired,
  currentPage: PropTypes.number.isRequired,
  onChangeUser: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
  onGetNextPageData: PropTypes.func.isRequired,
  onGridReady: PropTypes.func.isRequired,
  onOneOffApproachClick: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  userLoading: PropTypes.bool.isRequired,
  users: PropTypes.instanceOf(List).isRequired,
};

/** Backlog component. */
export const Backlog = memo(BacklogComponent);
